(function ($) {

	class PushLogic_Set_Reseller {

		constructor() {
			this.set_queried_location();
		}

		getEndpointUrl() {
			const host = window.location.host;
			const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
			const live_endpoint = 'https://shopify.treasuretrails.co.uk';

			if (host == 'treasure-trails-dev.myshopify.com') {
				return dev_endpoint;
			} else if (host == 'treasuretrails.co.uk') {
				return live_endpoint;
			} else {
				return live_endpoint;
			}
		}

		get_query_string_param(param) {
			var sPageURL = window.location.search.substring(1),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === param) {
					return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
				}
			}
		}

		set_queried_location() {
			var self = this,
				queried_reseller = self.get_query_string_param('RS');

			if (queried_reseller !== undefined || queried_reseller !== undefined) {
				self.set_reseller_location(queried_reseller);
			}
		}

		storage(name, value, type) {
			if (typeof (Storage) !== 'undefined') {
				if (type == 'set') {
					sessionStorage.setItem(name, value);
				} else if (type == 'get') {
					sessionStorage.getItem(name);
				} else if (type == 'remove') {
					sessionStorage.removeItem(name);
				}
			}
		}

		set_reseller_location(reseller_id) {
			var self = this,
				webhook_endpoint = '/apps/hub/reseller',
				data = { reseller_id: reseller_id };

			$.ajax({

				type: 'POST',
				url: webhook_endpoint,
				data: JSON.stringify(data),
				dataType: 'json',
				contentType: 'application/json',

				success: function (response) {
					if (response.success) {
						// self.storage('ttmb_search_location', response.data.company_name, 'set');
						// self.storage('ttmb_search_lat', parseFloat(response.data.lat), 'set');
						// self.storage('ttmb_search_lng', parseFloat(response.data.lng), 'set');
						localStorage.setItem('ttmb_reseller_id', response.data.company_id);
						localStorage.setItem('ttmb_reseller_name', response.data.company_name);
						self.get_reseller_static_html(response.data);
						return self.get_geojson();
					}
				},

				error: function (jqXHR, exception) {
					var error = '';

					if (jqXHR.status === 0) {
						error = 'Can\'t connect.\n Verify Network.';
					} else if (jqXHR.status == 404) {
						error = 'Requested page not found (404).';
					} else if (jqXHR.status == 500) {
						error = 'Internal Server Error (500).';
					} else if (jqXHR.status == 401) {
						error = 'Request Unauthorized (401).';
					} else if (exception === 'parsererror') {
						error = 'Requested JSON parse failed.';
					} else if (exception === 'timeout') {
						error = 'Time out error.';
					} else if (exception === 'abort') {
						error = 'Ajax request aborted.';
					} else {
						error = 'Uncaught Error.\n' + jqXHR.responseText;
					}

					error.log(error);
				},
			});
		}

		get_reseller_static_html() {
			html = '<div id="pltt-reseller-info">';
			html = html + '<h2>Welcome to Treasure Trails, the UKs leading provider of treasure hunts.</h2>';
			html = html + '<p>We hope you have a fantastic stay.</p>';
			html = html + '<p>Whilst you’re visiting, why not explore your local area with one of our adventures. See the sights, solve the clues and have some great fun along the way.</p>';
			html = html + '<p>The Trails can be downloaded straight onto the Treasure Trails App for instant access to adventure!</p>';
			html = html + '</div>';
			$(html).prependTo($('.ttmb-search-container'));
		}

		get_reseller_html(reseller_data) {
			var self = this,
				html = '<div class="ttmb-toggle-block pltt-toggle-block"><div class="ttmb-toggle-block-title"><h2>Reseller Information</h2></div>';
			if (reseller_data.company_content) {
				html = html + '<div class="ttmb-toggle-block-content pltt-table-wrap">';
			} else {
				html = html + '<div class="ttmb-toggle-block-content ttmbr-no-company-content pltt-table-wrap">';
			}
			// Left Content
			html = html + '<div>';
			html = html + reseller_data.qr_code;
			html = html + '</div>';
			html = html + '<div>';
			html = html + '<h4>' + reseller_data.company_name + '</h4>';
			html = html + '<small>ID: ' + reseller_data.company_id + '</small>';
			html = html + '<address>' + reseller_data.street + '<br />';
			html = html + reseller_data.city + '<br />';
			html = html + reseller_data.postcode + '<br />';
			html = html + reseller_data.county + '<br />';
			html = html + '<small>Tel: <a href="tel:+44' + parseInt(reseller_data.phone.replace(' ', '')) + '">' + reseller_data.phone + '</a></small></address>';
			if (reseller_data.website_url) {
				html = html + '<small>Web: <a href="' + reseller_data.website_url + '" target="_blank">' + reseller_data.website_url.replace('https://', '').replace('http://', '') + '</a></small></address>';
			}
			html = html + '</div>';
			//Right Content
			if (reseller_data.company_content) {
				html = html + '<div>' + reseller_data.company_content + '</div>';
			}
			html = html + '</div></div>';
			$(html).prependTo($('.ttmb-search-container'));
			self.toggle();
		}

		toggle() {
			var container = $('.pltt-toggle-block');

			$(container).each(function () {
				var current = $(this),
					table_wrap = current.find('.pltt-table-wrap'),
					title = current.find('h2'),
					storage_title = title.text().toLowerCase().replace(' ', '_') + '_open';

				table_wrap.hide();

				if (localStorage.hasOwnProperty(storage_title)) {
					var is_toggled = localStorage.getItem(storage_title);

					if (is_toggled == 'yes') {
						table_wrap.show();
						current.addClass('pltt-title-toggled');
					} else {
						current.removeClass('pltt-title-toggled');
					}
				}

				$(title).on('click', function () {
					table_wrap.slideToggle(function () {
						if ($(this).is(':visible')) {
							localStorage.setItem(storage_title, 'yes');
							current.addClass('pltt-title-toggled');
						} else {
							localStorage.setItem(storage_title, 'no');
							current.removeClass('pltt-title-toggled');
						}
					});
				});
			});
		}
	}

	new PushLogic_Set_Reseller;

})(jQuery);